
<span class="title">
  <slot name="title"></slot>
</span>
